"use client";

import type { CSSProperties } from "react";
import {
  CircleCheckIcon,
  CircleXIcon,
  InfoIcon,
  Loader2Icon,
  TriangleAlertIcon,
  XIcon,
} from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

import styles from "./toaster.module.css";

export const TOAST_DURATION_MS = 4000;

const TOAST_CLASSNAMES = {
  toast: styles.toast,
  icon: styles.icon,
  content: styles.content,
  title: styles.title,
  description: styles.description,
  actionButton: styles.action,
  cancelButton: styles.cancel,
  closeButton: styles.close,
  success: styles.success,
  error: styles.error,
  warning: styles.warning,
  info: styles.info,
  loading: styles.info,
};

const TOAST_ICONS = {
  success: <CircleCheckIcon strokeWidth={1.75} />,
  info: <InfoIcon strokeWidth={1.75} />,
  warning: <TriangleAlertIcon strokeWidth={1.75} />,
  error: <CircleXIcon strokeWidth={1.75} />,
  loading: <Loader2Icon className={styles.spin} strokeWidth={1.75} />,
  close: <XIcon strokeWidth={1.75} />,
};

const INSET = "1.25rem";

/** Storefront toasts: sonner, unstyled, drawn by `toaster.module.css` on the
 *  agency theme's roles. */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      style={{ "--width": "25rem" } as CSSProperties}
      position="bottom-right"
      offset={{
        top: INSET,
        right: INSET,
        bottom: `var(--toast-bottom-offset, ${INSET})`,
        left: INSET,
      }}
      mobileOffset={{
        top: INSET,
        right: INSET,
        bottom: `var(--toast-bottom-offset, ${INSET})`,
        left: INSET,
      }}
      duration={TOAST_DURATION_MS}
      visibleToasts={3}
      gap={10}
      closeButton
      toastOptions={{ unstyled: true, classNames: TOAST_CLASSNAMES }}
      icons={TOAST_ICONS}
      {...props}
    />
  );
}
